import { TAX_JV_REQUEST, TAX_JV_REQUEST_SUCCESS, TAX_JV_REQUEST_FAILURE } from "../types";

const initialState = {
  loading: false,
  error: null,
};

const taxJvReducer = (state = initialState, action) => {
  switch (action.type) {
    case TAX_JV_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case TAX_JV_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case TAX_JV_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default taxJvReducer;